import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { take } from 'rxjs';
import { GetProductCategoryTags } from 'src/app/models/product';
import { environment } from 'src/environments/environment';
import { ContentService } from '../content/content.service';

@Injectable({ providedIn: 'root' })
export class ProductTagService {
  private http = inject(HttpClient);
  private contentService = inject(ContentService);

  private readonly productComponentEndpoint = `${environment.apiOrigin}/ProductTag`;
  public merchantProductTags: GetProductCategoryTags[];

  load() {
    const id = this.contentService.getMerchantId();
    return this.getProductTag(id);
  }

  private getProductTag(merchantId: number) {
    return new Promise<void>((resolve) => {
      this.http
        .get<GetProductCategoryTags[]>(`${this.productComponentEndpoint}/ProductCategoryTags/${merchantId}`)
        .pipe(take(1))
        .subscribe({
          next: (data: GetProductCategoryTags[]) => {
            this.merchantProductTags = data;
            resolve();
          },
          error: () => {
            console.warn(`Tag service failed to load tags for merchant id ${merchantId}`);
            this.merchantProductTags = [];
            resolve();
          },
        });
    });
  }

  public getPrimaryTag(id: number): GetProductCategoryTags | undefined {
    return this.merchantProductTags?.find((tag) => tag.id === id);
  }
}

export const productCategoryTagServiceFactory = (productTagService: ProductTagService) => {
  return () => {
    return productTagService.load();
  };
};
